define([
	"dojo/query",
	"csi/html"
], function(query,html) {

	// Helper functions for the dialog and similar widgets that get and set values object

	return {
		externalizeValues: function(/*Object*/values, /*Widget?*/w) {
			// summary: Convert values internal to the dialog to values suitable for the external consuming.
			var newValues = {};
			var	v;

			for (var key in values) {
				v = values[key];

				if ((v instanceof Array) && (!w || this._checkBoxExists(w, key))) {
					// convert values returned by check boxes into real Boolean values
					v = v.length > 0;
				}

				newValues[key] = v;
			}

			return newValues;
		},

		internalizeValues: function(/*Object*/values, /*Widget?*/w) {
			// summary: Convert values external to the dialog to values suitable for this dialog.
			var newValues = {};
			var	v;

			for (var key in values) {
				v = values[key];

				if (((v instanceof Boolean) || (typeof v == "boolean")) && (!w || this._checkBoxExists(w, key))) {
					// Convert real Boolean values into the format required by check boxes.
					// The format is:
					// - an empty array for 'false' values
					// - an array with one element equals 'on' for true values
					v = v ? ["on"] : [];
				}

				newValues[key] = v;
			}

			return newValues;
		},

		_checkBoxExists: function(/*Widget*/w, /*String*/id) {
			// summary: returns true if the checkbox with this 'id' exists
			return query(".dijitCheckBox" + html.attributeSelector("widgetId", id), w.domNode).length;
		}
	};
});